import { useMemo, useCallback } from "react";
import { useIntl } from "react-intl";
import "../types/publisher";
import { formatDate } from "../utils/formatUtils";
export var usePublisherTable = function (onRowClick) {
    var formatMessage = useIntl().formatMessage;
    var handleNameClick = useCallback(function (item) {
        onRowClick(item);
    }, [onRowClick]);
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.publishers.table.name",
            }),
            key: "name",
            sortKey: "name",
            alwaysVisible: true,
            clickable: true,
            onClick: handleNameClick,
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.publishers.table.nameSuffix",
            }),
            key: "nameSuffix",
            sortKey: "nameSuffix",
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.publishers.table.qualifier",
            }),
            key: "qualifier",
            sortKey: "qualifier",
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.publishers.table.companyNumber",
            }),
            key: "companyNumber",
            sortKey: "companyNumber",
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.publishers.table.birthDate",
            }),
            key: "birthDate",
            sortKey: "birthDate",
            cellRenderer: function (item) {
                return !item.companyNumber && item.birthDate
                    ? formatDate(item.birthDate)
                    : "";
            },
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.publishers.table.region",
            }),
            key: "regionId",
            sortKey: "region",
            cellRenderer: function (item) { var _a, _b, _c; return (_c = (_b = (_a = item.mainAddress) === null || _a === void 0 ? void 0 : _a.region) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : ""; },
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.publishers.table.email",
            }),
            key: "contacts",
            id: "email",
            sortKey: "email",
            cellRenderer: function (item) { var _a; return (_a = item.primaryEmail) !== null && _a !== void 0 ? _a : ""; },
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.publishers.table.phone",
            }),
            key: "contacts",
            id: "phone",
            sortKey: "phone",
            cellRenderer: function (item) { var _a; return (_a = item.primaryPhone) !== null && _a !== void 0 ? _a : ""; },
        },
    ]; }, [formatMessage, handleNameClick]);
    return {
        columns: columns,
    };
};
